import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '../../shared/Constants';



@Injectable()
export class ListPriceService {

  constructor(public http: HttpClient) { }

  getPriceListProductByidClient(idClient) {

    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('jwt')));
    return this.http.get(Constants.URL_BACKEND + '/price-list-by-client', { headers: headers, params: { idClient: idClient } });
  }
}



// WEBPACK FOOTER //
// ./src/app/system/services/list-price.service.ts